import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Linking,
    Text,
    TextInput
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';
import moment from "moment";
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
const importantImg = require("../images/login/ImportantInfo.png");
const IconDownloadImg = require("../images/login/downloadIcon.png");
const completeRequest = require("../images/login/activationComplete.png");
const imgJdsLogo = require("../images/Header/JdsLogo.png");
const imgHelpIcon = require("../images/Header/helpIcon.png");
const imgGreenVector = require("../images/login/greenVector.png");
const imgJordanLogo = require("../images/login/jdsJordan.png");
class Activation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScrolled: false,
            brands: [],
            joImgPos: 0,
            hideScrollTopButton: true,
            showPickedFile: false,
            PickedFileName: '',
            changableStyle: AppStyles.loginButtonStyles,
            changableTextStyle: AppStyles.loginButtonTextStyles,
            changableStyle2: AppStyles.AcitvateButtonStyles,
            changableTextStyle2: AppStyles.AcitvateButtonTextStyles,
            failedActivation: false,
            showImportantInfo: false,
            yourAccountNo: '',
            activateAccount: {},
            fileToUpload: false,
            activationComplete: false,
            loading: false,
            activationStatus: "",
        };
    }
    Pressables = {};

    async componentDidMount() {
        // const activateAccount = await ServerOperations.getActivateAccountRequest(this.state.yourAccountNo, this.state.PickedFileName);
        // if (activateAccount) {
        //     this.setState({ activateAccount });
        // }
    }

    renderCompleteActivation = () => {
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    width: width,
                    height: isMobile ? '150%' : '100%',
                    position: 'absolute',
                    top: isMobile ? '10%' : '7%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: '#FFF',
                    alignItems: 'center',
                    gap: 32,
                }}>
                <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: isMobile ? undefined : '20%' }}>
                    <Text style={[AppStyles.H1Styles, { textAlign: 'center', width: width - 40 }]}>Activation Request{'\n'}Complete</Text>
                    <Image source={completeRequest} style={{ width: 115, height: 115, marginTop: 24 }}></Image>
                    <View style={{ alignSelf: 'stretch', marginTop: 24, justifyContent: 'center', alignItems: 'center' }}>
                        <Text style={[AppStyles.BodyTextStyles, { color: '#72A775' }]}>
                            {this.state.activationStatus}
                        </Text>
                    </View>
                </View>
            </Animatable.View>
        );
    };

    renderImportantInformation = () => {
        return (
            <Animatable.View
                animation="slideInUp"
                duration={500}
                style={{
                    width: width,
                    height: '150%',
                    position: 'absolute',
                    top: '43%',
                    transform: [{ translateX: -(width - 20) / 2 }, { translateY: -237.5 }],
                    zIndex: 1000,
                    flexDirection: 'column',
                    backgroundColor: '#FFF',
                    alignItems: 'center',
                    gap: 32,
                    borderTopRightRadius: 16,
                    borderTopLeftRadius: 16,
                    borderWidth: 1,
                    borderColor: 'rgba(215, 215, 215, 0.50)',
                }}
            >
                <TouchableOpacity
                    onPress={() => this.setState({ showImportantInfo: false })}
                    style={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        width: 30,
                        height: 30,
                        borderRadius: 15,
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderColor: Styles.appColor1,
                        borderWidth: 1,
                    }}
                >
                    <Text style={{ color: Styles.appColor1, fontSize: 15 }}>X</Text>
                </TouchableOpacity>
                <View style={{ marginTop: 50 }}>
                    <Image source={imgGreenVector} style={{ width: 110.115, height: 101.534 }} />
                    <Image source={importantImg} style={{ width: 108.684, height: 92.239, position: 'absolute', top: 8 }} />
                </View>
                <View>
                    <Text style={[AppStyles.H2Styles]}>Important information{'\n'}        for sign up</Text>
                </View>
                <Text style={[AppStyles.LabelTextStyles, { textAlign: 'center' }]}>
                    This app is exclusively for our customers.
                    {'\n'}You need an account assigned by Jordan Drugstore Company
                    {'\n'}(JDS). Use the account number provided by JDS and the
                    {'\n'}phone number associated with your JDS account.
                    {'\n'}
                    {'\n'}
                    {'\n'}If you’ve already activated your account online, simply Sign
                    {'\n'}In. If not, click Activate Online Account to set up your access.
                    {'\n'}Need help? Contact us for assistance.
                </Text>
            </Animatable.View>
        );
    }


    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <TouchableOpacity onPress={() => window.history.back()} style={{ paddingHorizontal: isMobile ? undefined : 64 }}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => this.setState({ showModal: true })} style={{ paddingRight: isMobile ? undefined : 64 }}>
                    {/* <Image source={imgHelpIcon} style={{ width: 19.2, height: 19.2 }} /> */}
                </TouchableOpacity>
            </View>
        )
    }


    renderMobile() {
        var paddingHorz = 20;
        var paddingHorz2 = undefined;
        if (this.state.showImportantInfo == true) {
            paddingHorz = undefined;
            paddingHorz2 = 20;
        };
        if (this.state.activationComplete == true) {
            paddingHorz = undefined;
        };

        return (
            <View style={styles.container}>
                {this.renderHeaderMobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, paddingHorizontal: paddingHorz }}>
                        {Commons.loadFonts(this)}
                        {Styles.renderVSeparator(0)}
                        <View style={{ paddingHorizontal: paddingHorz2 }}>
                            {this.renderPart1Mobile()}
                        </View>
                        {this.renderPart2Mobile()}
                        {this.state.showImportantInfo == true && this.renderImportantInformation()}
                        {this.state.activationComplete == true && this.renderCompleteActivation()}

                        {/* {Commons.renderFooter({}, this)} */}
                    </View>
                </ScrollView >
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        styles = this.styles();
        return (
            <View style={styles.container}>
                {Commons.loadFonts(this)}
                {this.renderHeaderMobile()}
                {this.renderPart1()}
                {this.state.activationComplete == true && this.renderCompleteActivation()}

            </View >
        );
    }

    renderPart1 = () => {
        var textInputStyle1 = AppStyles.TextInputStyles1Secondary;
        if (this.state.failedActivation) {
            textInputStyle1 = AppStyles.TextInputStyles4;
        }
        return (
            <View style={{ width, height: height - 90, backgroundColor: '#FFF', alignItems: 'center', justifyContent: 'center' }}>
                <View style={{ position: 'absolute', bottom: 0, right: 30 }}>
                    <Image source={imgJordanLogo} style={{ width: 400, height: 500 }} />
                </View>
                <View style={{ width: 395, alignSelf: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.20)', backgroundColor: '#FFF' }}>
                    <View style={{ display: "flex", flexDirection: "column", alignItems: "center", alignSelf: "stretch", gap: 8 }}>
                        <View style={{ display: "flex", alignItems: "center", justifyContent: "center", alignSelf: "stretch", marginTop: 50 }}>
                            <Text style={[AppStyles.H1Styles, { fontSize: 28 }]}>{STRINGS.Activate_your_Account}</Text>
                        </View>
                        <View style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch", marginTop: 24, width: 373, paddingHorizontal: 16 }}>
                            <View>
                                <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Account_Number}</Text>
                            </View>
                            <TextInput style={[textInputStyle1, { width: 362, color: Styles.appColor1 }]}
                                value={this.state.yourAccountNo}
                                keyboardType="numeric"
                                placeholder={STRINGS.Your_Account_Number}
                                placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                                onChangeText={(text) => this.setState({ yourAccountNo: text })}
                                onBlur={() => this.getCustomerMask(this.state.yourAccountNo)}>
                            </TextInput>
                        </View>
                        <View style={{ display: 'flex', width: width - 40, marginTop: 16, flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                            <TouchableOpacity style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 7 }}
                                onPress={() => { Linking.openURL(Constants.ACTIVATION_FORM) }}>
                                <Text style={[AppStyles.ButtonTextStyles, { textDecorationLine: 'underline' }]}>{STRINGS.Download_online_account_activation}</Text>
                                <Image source={IconDownloadImg} style={{ width: 14, height: 14, marginTop: 2 }} />
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 50, alignSelf: 'stretch', width: 373, marginHorizontal: 16, marginBottom: 40 }}>
                        <TouchableOpacity style={[this.state.changableStyle, { width: 362 }]}
                            onPress={() => {
                                const input = document.createElement('input');
                                input.type = 'file';
                                input.accept = 'application/pdf,image/*';
                                input.onchange = (event) => {
                                    const fileToUpload = event.target.files[0];
                                    if (fileToUpload) {
                                        this.setState({
                                            showPickedFile: true,
                                            PickedFileName: fileToUpload.name,
                                            changableStyle: AppStyles.secondaryButtonStyles,
                                            changableTextStyle: AppStyles.AcitvateButtonTextStyles,
                                            changableStyle2: AppStyles.loginButtonStyles,
                                            changableTextStyle2: AppStyles.loginButtonTextStyles,
                                            fileToUpload
                                        });
                                    }
                                };
                                input.click();
                            }}
                        >
                            <Text style={this.state.changableTextStyle}>{STRINGS.Choose_file}</Text>
                        </TouchableOpacity>
                        {this.state.showPickedFile && (

                            <Text style={[AppStyles.SecondaryTextStyles, { alignItems: 'flex-start', width: 375 }]}>{this.state.fileToUpload ? this.state.PickedFileName : "No file chosen"}</Text>
                        )}
                        <TouchableOpacity style={[this.state.changableStyle2, { width: 362 }]}
                            onPress={async () => {
                                loaderHandler.showLoader(STRINGS.loading, this);
                                const okCustID = await this.getCustomerMask(this.state.yourAccountNo);
                                if (!okCustID) {
                                    loaderHandler.hideLoader();
                                    return;
                                }
                                this.setState({ showPickedFile: true });
                                if (this.state.failedActivation == false && this.state.fileToUpload) {
                                    const resp = await this.postDocument();
                                    if (!resp || resp.ERROR) {
                                        alert("Unable to upload. " + resp.ERROR);
                                    } else {
                                        this.postDataOnPick();
                                    }
                                }
                                loaderHandler.hideLoader();
                            }}>
                            <Text style={this.state.changableTextStyle2}>{STRINGS.Upload}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        )
    }

    renderPart1Mobile = () => {
        return (<View
            style={{
                width: width - 40,
                flexDirection: 'column',
                backgroundColor: 'white',
                alignItems: 'center',
                gap: 16,
            }}
        >
            <View style={{ display: 'flex', marginTop: 32, flexDirection: 'column', alignItems: 'center', gap: 8, alignSelf: 'stretch' }}>
                <View style={{ display: 'flex', marginTop: 24, justifyContent: 'center', alignSelf: 'stretch', alignItems: 'center' }}>
                    <Text style={[AppStyles.H1Styles, {}]}>{STRINGS.Activate_your_Account}</Text>
                </View>
                <View style={{ justifyContent: 'center', alignSelf: 'stretch', alignItems: 'center', marginTop: 30 }}>
                    <Text style={[AppStyles.SecondaryTextStyles, { alignItems: 'center', textAlign: 'center' }]}>
                        {STRINGS.activation_paragraph}
                    </Text>
                </View>
            </View>

            <View style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8, alignSelf: "stretch", marginTop: 30, width: width - 40 }}>
                <View>
                    <Text style={[AppStyles.LabelTextStyles]}>{STRINGS.Account_Number}</Text>
                </View>
                {(this.state.failedActivation == false) && (
                    <TextInput style={[AppStyles.TextInputStyles1Secondary]}
                        value={this.state.yourAccountNo}
                        keyboardType="numeric"
                        placeholder={STRINGS.Your_Account_Number}
                        placeholderTextColor={'rgba(59, 98, 127, 0.50)'}
                        onChangeText={(text) => this.setState({ yourAccountNo: text })}
                        onBlur={() => this.getCustomerMask(this.state.yourAccountNo)}>
                    </TextInput>
                )}
                {(this.state.failedActivation == true) && (
                    <View style={{ alignSelf: 'stretch' }}>
                        <TextInput style={[AppStyles.TextInputStyles4, { color: AppStyles.appColor1 }]}
                            value={this.state.yourAccountNo}
                            keyboardType="numeric"
                            placeholder={this.state.yourAccountNo}
                            placeholderTextColor={AppStyles.appColor1}
                            onChangeText={(text) => this.setState({ yourAccountNo: text })}
                            onBlur={() => this.getCustomerMask(this.state.yourAccountNo)}>
                        </TextInput>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: '#D70202', marginTop: 10 }]}>{STRINGS.activation_error_message}</Text>
                    </View>
                )}
            </View>

            <View style={{ display: 'flex', width: width - 40, marginTop: 16, flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                <TouchableOpacity style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 7 }}
                    onPress={() => { Linking.openURL(Constants.ACTIVATION_FORM) }}>
                    <Text style={[AppStyles.ButtonTextStyles, { textDecorationLine: 'underline' }]}>{STRINGS.Download_online_account_activation}</Text>
                    <Image source={IconDownloadImg} style={{ width: 14, height: 14, marginTop: 2 }} />
                </TouchableOpacity>
            </View>

            <View style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 20, alignSelf: 'stretch', width: width - 40 }}>
                <TouchableOpacity style={this.state.changableStyle}
                    onPress={() => {
                        const input = document.createElement('input');
                        input.type = 'file';
                        input.accept = 'application/pdf,image/*';
                        input.onchange = (event) => {
                            const fileToUpload = event.target.files[0];
                            if (fileToUpload) {
                                this.setState({
                                    showPickedFile: true,
                                    PickedFileName: fileToUpload.name,
                                    changableStyle: AppStyles.secondaryButtonStyles,
                                    changableTextStyle: AppStyles.AcitvateButtonTextStyles,
                                    changableStyle2: AppStyles.loginButtonStyles,
                                    changableTextStyle2: AppStyles.loginButtonTextStyles,
                                    fileToUpload
                                });
                            }
                        };
                        input.click();
                    }}
                // disabled={this.state.showPickedFile}
                >
                    <Text style={this.state.changableTextStyle}>{STRINGS.Choose_file}</Text>
                </TouchableOpacity>
                {this.state.showPickedFile && (

                    <Text style={[AppStyles.SecondaryTextStyles, { alignItems: 'flex-start', width: width - 40 }]}>{this.state.fileToUpload ? this.state.PickedFileName : "No file chosen"}</Text>
                )}
                <TouchableOpacity style={this.state.changableStyle2}
                    onPress={async () => {
                        loaderHandler.showLoader(STRINGS.loading, this);
                        const okCustID = await this.getCustomerMask(this.state.yourAccountNo);
                        this.setState({ showPickedFile: true });
                        if (this.state.failedActivation == false && this.state.fileToUpload) {
                            const resp = await this.postDocument();
                            if (!resp || resp.ERROR) {
                                alert("Unable to upload. " + resp.ERROR);
                            } else {
                                this.postDataOnPick();
                            }
                        }
                        loaderHandler.hideLoader();
                    }}>
                    {/* onPress={async () => {
                        loaderHandler.showLoader(STRINGS.loading, this);
                        this.getCustomerMask(this.state.yourAccountNo);
                        this.postDocument();

                    }}> */}
                    <Text style={this.state.changableTextStyle2}>{STRINGS.Upload}</Text>
                </TouchableOpacity>
            </View>
        </View>

        )
    }

    postDataOnPick = async () => {
        const activateAccount = await ServerOperations.getActivateAccountRequest(this.state.yourAccountNo, this.state.filename);

        if (activateAccount.ERROR == "PENDING") {
            this.setState({ activationStatus: "Your activation request has already been submitted and is currently under review.", activationComplete: true });
            return;
        }
        if (activateAccount.ERROR == "ACTIVE") {
            this.setState({ activationStatus: "Your account has already been activated and is ready for use.", activationComplete: true });
        }
        if (activateAccount.MSG == "SUBMITTED") {
            // this.setState({ activateAccount });
            // console.log(activateAccount);
            this.setState({ activationStatus: "Your request has been submitted successfully. Our\ncall center will contact you as soon as possible.", activationComplete: true });
        }
    }


    getCustomerMask = async () => {
        // loaderHandler.showLoader(STRINGS.please_wait, self);
        if (this.state.yourAccountNo) {
            const resp = await ServerOperations.getCustomerPhoneMask(this.state.yourAccountNo);
            if (resp.ERROR) {
                this.setState({ failedActivation: true });
                return false;
            } else {
                this.setState({ failedActivation: false });
                return true;
            }
        }
        loaderHandler.hideLoader();
        this.setState({ failedActivation: true });
        return false;
    }

    postDocument = async () => {
        const fileToUpload = this.state.fileToUpload;
        const name = moment(new Date()).format('YYYYMMDDHHMMSS') + "." + fileToUpload.name;
        const response = await ServerOperations.pickUploadHttpRequest(fileToUpload, "activation\\" + name);
        this.setState({ filename: name });
        if (response === Constants.networkError_code) {
            this.setState({ uploaded: false });
            console.log("Network Error");
            return { ERROR: "Network Error" };
        }
        if (response.ok) {
            const resp = await response.json();
            this.setState({ fileToUpload: undefined, failedActivation: false, activationComplete: true });
            console.log("Uploaded Successfully");
            return resp;
        }
    }

    // postDocument = async (fileName) => {
    //     let name = 'activation' + "." + fileName;
    //     console.log(name);
    //     const response = await ServerOperations.pickUploadHttpRequest(fileName, name);
    //     console.log(response.url);

    //     if (response.ERROR) {
    //         console.log(response.ERROR);
    //         return null;
    //     }else {
    //         var attach = './attachment/ftp/jds/' + name;
    //         console.log(attach);
    //         return response.url;
    //     }
    //         // const resp = await response.json();
    //         // this.setState({ fileToUpload: undefined, failedActivation: false, activationComplete: true,activationStatus: "Your request has been submitted successfully. Our \ncall center will contact you as soon as possible." });
    //         // return name;
    // }

    renderPart2 = () => {

    }

    renderPart2Mobile = () => {

    }





    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Activation;
